import LoginSwitcher from "./modules/main/components/LoginSwitcher";
import { useBuildUpdateState } from "shared-components";
import BuildUpdateBanner from "./modules/main/components/BuildUpdateBanner";
import { buildUpdateController } from "./modules/main/components/buildUpdate";

const Root = () => {
  const buildUpdateState = useBuildUpdateState(buildUpdateController);
  const showUpdateBanner =
    buildUpdateState.isUpdateAvailable &&
    buildUpdateState.updateMode === "confirm";

  return (
    <div className="container-fluid">
      {showUpdateBanner ? (
        <BuildUpdateBanner
          isApplyingUpdate={buildUpdateState.isApplyingUpdate}
          onApplyUpdate={buildUpdateController.applyPendingUpdate}
        />
      ) : null}
      <div style={showUpdateBanner ? { paddingTop: "112px" } : undefined}>
        <LoginSwitcher />
      </div>
    </div>
  );
};

export default Root;
